import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import Button from 'eventbrite_design_system/button/Button';
import EBPropTypes from 'js-utils/prop-types';

import {
    TYPE_SUBMIT,
    STYLE_FILL,
    SIZE_BLOCK,
} from 'eventbrite_design_system/button/constants';

export default class FormSubmitButton extends React.PureComponent {
    static propTypes = {
        buttonCTA: EBPropTypes.translation.isRequired,
        submitDisabled: PropTypes.bool,
        buttonClasses: PropTypes.string,
        onClick: PropTypes.func,
    };

    static defaultProps = {
        onClick: noop,
    };

    render() {
        const {
            buttonCTA,
            submitDisabled,
            buttonClasses,
            onClick,
        } = this.props;

        return (
            <div className={buttonClasses}>
                <Button
                    onClick={onClick}
                    type={TYPE_SUBMIT}
                    style={STYLE_FILL}
                    size={SIZE_BLOCK}
                    disabled={submitDisabled}
                    data-automation="signup-submit-button"
                >
                    {buttonCTA}
                </Button>
            </div>
        );
    }
}
